export default "__VITE_ASSET__BwWA9seZ__"